<template>

    <el-row v-if="existed" class="bottom20">
        <el-row class="column-name" justify="start">
            <span>附件</span>
            <div class="navbar-right">
                <el-button type="info" plain size="minimum" @click="toAdd" :disabled="disabled" v-if="addable">添加附件</el-button>
            </div>
        </el-row>
        <el-row>
            <el-upload ref="upload" :action="''" class="attachment "
                       :http-request="uploadFile"
                       :on-preview="handlePreview"
                       :before-upload="beforeAvatarUpload"
                       :before-remove="beforeRemove"
                       :on-remove="handleRemove"
                       :file-list="fileList"
                       :disabled="disabled"
                       multiple>
                <el-button ref="selectFileBtn" slot="trigger" size="small" type="primary">选取文件</el-button>
                <div class="el-upload__tip" slot="tip">
                    <div v-show="fileList.length <= 0">
                        暂无附件
                    </div>
                </div>
            </el-upload>
        </el-row>
    </el-row>
</template>

<script>

    import AttachmentServer from '../../api/attachment'

    export default {

        name: 'attachment',

        props: {
            ownerTable: {},
            docType: {},
            ownerId: {},
            disabled: {
                type: Boolean,
                default: false
            },
            addable: {
                type: Boolean,
                default: true
            },
            existed: {
                type: Boolean,
                default: true,
            },
            maxSize: {
                type: Number,
                default: 5
            },
            isCanDeleteFile: {
                type: Function,
                default: async () => {
                  return true;
                }
            },
        },

        data() {
            return {
                fileList: [],
                isAllow2Upload: true
            }
        },

        methods: {
            toAdd() {
                this.$refs.selectFileBtn.$el.click();
            },

            handleRemove(file, fileList) {
                this.deleteFile(file.docLinkSid);
            },

            handlePreview(file) {
                window.open(file.url);
            },

            beforeAvatarUpload(file) {
                const sizeIsValid = file.size <= this.maxSize * 1024 * 1024;
                if (!sizeIsValid) {
                    this.$message.error(`上传附件大小不能超过${this.maxSize}MB!`);
                    this.isAllow2Upload = false;
                }
                return sizeIsValid;
            },

            async beforeRemove(file, fileList) {
              let promise;
              if (!this.isAllow2Upload) {
                promise = Promise.resolve(true);
              } else {
                let result = false;
                try {
                  result = await this.isCanDeleteFile(file);
                } catch (e) {
                  this.$message.error(e);
                }
                if (result) {
                  promise = this.$confirm(`确定移除 ${file.name}？`);
                } else {
                  promise = Promise.reject(false);
                }
              }
              return promise;
            },

            uploadFile(e) {
                let params = {
                    file: e.file,
                    ownerTable: this.ownerTable,
                    docType: this.docType,
                    ownerId: this.ownerId,
                }
                AttachmentServer.attachment.upload(params).then(responseBody => {
                    this.$message("上传成功");
                    this.downloadList(this.ownerTable, this.ownerId);
                    this.$emit('refresh');
                })

            },

            downloadList(ownerTable, ownerId) {
                let params = {
                    ownerTable: this.ownerTable,
                    ownerId: this.ownerId,
                }
                AttachmentServer.attachment.downloadList(params).then(responseBody => {
                    responseBody.forEach(e => {
                        e.name = `${e.createDate} ${e.createByRealName} ${e.name}`;
                    })
                    this.fileList = responseBody;
                    this.$emit('afterAttachDownloadFunc', this.fileList);
                });
            },

            deleteFile(docLinkSid) {
                AttachmentServer.attachment.delete(docLinkSid).then(responseBody => {
                    this.$message("删除成功");
                    this.$emit('refresh')
                    this.downloadList(this.ownerTable, this.ownerId);
                })
            }
        },

        watch: {
            ownerId: {
                immediate: true,
                deep: true,
                handler: function (newVal, oldVal) {
                    if (newVal) {
                        this.downloadList(this.ownerTable, this.ownerId);
                    }
                }
            },

        },
        mounted() {
            console.log('mounted', this)
        }

    }
</script>

<style>
    .attachment div.el-upload.el-upload--text {
        display: none;
    }
</style>
